export function CsrfTokenField() {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
  return <input type="hidden" name="authenticity_token" value={token} />
}
